import { axios, base } from '../http';

export const batchDeleteStudentScoreRecords = (params) => {
  return axios.post(`${base}/api/EvaluationDimension/BatchDeleteStudentScoreRecords`, params);
};

// 博客模块管理

export const getMoralEducationBigScreenData = (params) => {
  return axios
    .get(`${base}/api/MoralEducationBigScreen/GetData`, { params: params })
    .then((res) => res.data);
};

// 积分大屏

export const getMoralPointBigScreenData = (params) => {
  return axios
    .get(`${base}/api/MoralPointBigScreen/GetData`, { params: params })
    .then((res) => res.data);
};

//消费汇总报�?

export const getHonorTypeListPage = (params) => {
  return axios.get(`${base}/api/HonorType/get`, { params: params });
};
//编辑荣誉类型

export const editHonorType = (params) => {
  return axios.put(`${base}/api/HonorType/put`, params);
};
//新增荣誉类型

export const addHonorType = (params) => {
  return axios.post(`${base}/api/HonorType/post`, params);
};
//删除荣誉类型

export const deleteHonorType = (params) => {
  return axios.delete(`${base}/api/HonorType/Delete`, { params: params });
};

//获取荣誉

export const getDeptHonorRecordListPage = (params) => {
  return axios.get(`${base}/api/DeptHonorRecord/get`, { params: params });
};
//编辑荣誉

export const editDeptHonorRecord = (params) => {
  return axios.put(`${base}/api/DeptHonorRecord/put`, params);
};
//新增荣誉

export const addDeptHonorRecord = (params) => {
  return axios.post(`${base}/api/DeptHonorRecord/post`, params);
};
//删除荣誉

export const deleteDeptHonorRecord = (params) => {
  return axios.delete(`${base}/api/DeptHonorRecord/Delete`, { params: params });
};

//获取学期课程配置

export const getHonorLineApproverListPage = (params) => {
  return axios.get(`${base}/api/HonorLineApprover/GetList`, { params: params });
};

export const addHonorLineApprover = (params) => {
  return axios.post(`${base}/api/HonorLineApprover/Add`, params);
};

export const editHonorLineApprover = (params) => {
  return axios.post(`${base}/api/HonorLineApprover/Edit`, params);
};

export const removeHonorLineApprover = (params) => {
  return axios.post(`${base}/api/HonorLineApprover/Delete`, null, { params: params });
};

// 荣誉采集 - 抄送人员配置

export const getHonorLineCcPersonListPage = (params) => {
  return axios.get(`${base}/api/HonorLineCcPerson/GetList`, { params: params });
};

export const addHonorLineCcPerson = (params) => {
  return axios.post(`${base}/api/HonorLineCcPerson/Add`, params);
};

export const editHonorLineCcPerson = (params) => {
  return axios.post(`${base}/api/HonorLineCcPerson/Edit`, params);
};

export const removeHonorLineCcPerson = (params) => {
  return axios.post(`${base}/api/HonorLineCcPerson/Delete`, null, { params: params });
};

// 荣誉采集 - 后台记录汇总与导出

export const getHonorCollectionRecordListPage = (params) => {
  return axios.get(`${base}/api/HonorCollectionRecordManage/GetRecordList`, { params: params });
};

export const getHonorCollectionPlatformSummary = (params) => {
  return axios.get(`${base}/api/HonorCollectionRecordManage/GetPlatformSummary`, { params: params });
};

export const getHonorCollectionRecordDetail = (params) => {
  return axios.get(`${base}/api/HonorCollectionRecordManage/GetRecordDetail`, { params: params });
};

export const exportHonorCollectionRecords = (params) => {
  return axios.get(`${base}/api/HonorCollectionRecordManage/ExportRecordList`, {
    params: params,
    responseType: "blob",
  });
};

export const getMoralMallAdminListPage = (params) => {
  return axios.get(`${base}/api/MoralMallAdmin/GetList`, { params: params });
};

export const addMoralMallAdmin = (params) => {
  return axios.post(`${base}/api/MoralMallAdmin/Add`, params);
};

export const editMoralMallAdmin = (params) => {
  return axios.post(`${base}/api/MoralMallAdmin/Edit`, params);
};

export const removeMoralMallAdmin = (params) => {
  return axios.post(`${base}/api/MoralMallAdmin/Delete`, null, { params: params });
};

// 校级奖品管理（德育商城管理员）

export const getSchoolPrizeListForAdmin = (params) => {
  return axios.get(`${base}/api/MoralMallPrizeAdmin/GetList`, { params: params });
};

export const saveSchoolPrizeForAdmin = (teacherId, data, departmentId) => {
  return axios.post(`${base}/api/MoralMallPrizeAdmin/Save`, data, { params: { teacherId, departmentId } });
};

export const updateSchoolPrizeShelfForAdmin = (data) => {
  const departmentId = data && data.DepartmentId ? data.DepartmentId : 0
  return axios.post(`${base}/api/MoralMallPrizeAdmin/UpdateShelf`, data, { params: { departmentId } });
};

export const deleteSchoolPrizeForAdmin = (params) => {
  return axios.post(`${base}/api/MoralMallPrizeAdmin/Delete`, null, { params: params });
};

export const getSchoolPrizeReleaseRecords = (params) => {
  return axios.get(`${base}/api/MoralMallPrizeAdmin/GetClassReleaseRecords`, { params: params });
};

export const getSchoolPrizeExchangeRecords = (params) => {
  return axios.get(`${base}/api/MoralMallPrizeAdmin/GetExchangeRecords`, { params: params });
};

export const revokeSchoolPrizeExchangeRecord = (data) => {
  return axios.post(`${base}/api/MoralMallPrizeAdmin/RevokeExchange`, data);
};

// 班级奖品管理（班级维度）

export const getMoralPrizeExchangeListForAdmin = (params) => {
  return axios.get(`${base}/api/MoralPrizeExchangeAdmin/GetList`, { params: params });
};

export const exportMoralPrizeExchangeRecords = (params) => {
  return axios.get(`${base}/api/MoralPrizeExchangeAdmin/Export`, {
    params: params,
    skipGlobalHttpErrorToast: true,
    responseType: 'blob',
  });
};

// 德育分卡管理（德育商城管理员）

export const generateMoralPointCards = (data) => {
  const departmentId = data && data.DepartmentId ? data.DepartmentId : 0
  return axios.post(`${base}/api/MoralPointPhysicalCardAdmin/Generate`, data, { params: { departmentId } });
};

export const previewMoralPointCardBatchNo = () => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/PreviewBatchNo`);
};

export const listMoralPointCardBatches = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/GetBatchList`, { params: params });
};

export const exportMoralPointCardBatch = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/ExportBatch`, {
    params: params,
    skipGlobalHttpErrorToast: true,
    responseType: 'blob',
  });
};

export const listMoralPointCards = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/GetList`, { params: params });
};

export const recycleMoralPointCard = (data) => {
  const departmentId = data && data.DepartmentId ? data.DepartmentId : 0
  return axios.post(`${base}/api/MoralPointPhysicalCardAdmin/Recycle`, data, { params: { departmentId } });
};

export const recycleMoralPointCardsBatch = (data) => {
  return axios.post(`${base}/api/MoralPointPhysicalCardAdmin/RecycleBatch`, data);
};

export const enableMoralPointCard = (data) => {
  const departmentId = data && data.DepartmentId ? data.DepartmentId : 0
  return axios.post(`${base}/api/MoralPointPhysicalCardAdmin/Enable`, data, { params: { departmentId } });
};

export const updateMoralPointCardPoints = (data) => {
  const departmentId = data && data.DepartmentId ? data.DepartmentId : 0
  return axios.post(`${base}/api/MoralPointPhysicalCardAdmin/UpdatePoints`, data, { params: { departmentId } });
};

export const listMoralPointCardRecycleLogs = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/GetRecycleLogList`, { params: params });
};

export const exportMoralPointCardRecycleLogs = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/ExportRecycleLogs`, {
    params: params,
    skipGlobalHttpErrorToast: true,
    responseType: 'blob',
  });
};

export const listMoralPointCardBatchRecycleSummary = (params) => {
  return axios.get(`${base}/api/MoralPointPhysicalCardAdmin/GetBatchRecycleCardSummary`, { params: params });
};

// 获取校区列表

export const getDutyInspectCategoryListPage = (params) => {
  return axios.get(`${base}/api/DutyInspectCategory/Get`, { params: params });
};

// 获取值日检查类�?

export const getParentsByDepartment = (params) => {
  return axios.get(`${base}/api/DutyInspectCategory/GetParentsByDepartment`, {
    params: params,
  });
};

// 新增值日检查类�?

export const addDutyInspectCategory = (params) => {
  return axios.post(`${base}/api/DutyInspectCategory/Post`, params);
};

// 编辑值日检查类�?

export const editDutyInspectCategory = (params) => {
  return axios.put(`${base}/api/DutyInspectCategory/Put`, params);
};

// 删除值日检查类�?

export const deleteDutyInspectCategory = (params) => {
  return axios.delete(`${base}/api/DutyInspectCategory/Delete`, {
    params: params,
  });
};

// 获取值日检查类别下的检查项

export const getDutyInspectItemListPage = (params) => {
  return axios.get(`${base}/api/DutyInspectCategory/GetItems`, {
    params: params,
  });
};

// 新增值日检查类别下的检查项

export const addDutyInspectItem = (params) => {
  return axios.post(`${base}/api/DutyInspectCategory/PostItem`, params);
};

// 编辑值日检查类别下的检查项

export const editDutyInspectItem = (params) => {
  return axios.put(`${base}/api/DutyInspectCategory/PutItem`, params);
};

// 删除值日检查类别下的检查项

export const deleteDutyInspectItem = (params) => {
  return axios.delete(`${base}/api/DutyInspectCategory/DeleteItem`, {
    params: params,
  });
};

// 获取二级分类（树形，下拉用）

export const getSecondLevel = (params) => {
  return axios.get(`${base}/api/DutyInspectCategory/GetSecondLevel`, {
    params: params,
  });
};

// 值周扣分项级联树（一级→二级→扣分项，对齐班务 GetAdditionItemTree；课程配置传 campusId=0）

export const getDeductionItemTree = (params) => {
  return axios.get(`${base}/api/DutyInspectCategory/GetDeductionItemTree`, {
    params: params,
  });
};

// 获取学生评价维度

export const getEvaluationDimensionListPage = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/Get`, { params: params });
};

// 获取维度二级分类树（下拉用）

export const getEvaluationDimensionSecondLevel = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetSecondLevel`, {
    params: params,
  });
};

// 获取学生评价维度

export const getEvaluationDimensionParentsByDepartment = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetParentsByDepartment`, {
    params: params,
  });
};

// 新增学生评价维度

export const addEvaluationDimension = (params) => {
  return axios.post(`${base}/api/EvaluationDimension/Post`, params);
};

// 编辑学生评价维度

export const editEvaluationDimension = (params) => {
  return axios.put(`${base}/api/EvaluationDimension/Put`, params);
};

// 删除学生评价维度

export const deleteEvaluationDimension = (params) => {
  return axios.delete(`${base}/api/EvaluationDimension/Delete`, {
    params: params,
  });
};

// 获取学生评价维度下的评价�?

export const getStudentEvaluationItemListPage = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetEvaluationItems`, {
    params: params,
  });
};

// 新增学生评价维度下的评价�?

export const addStudentEvaluationItem = (params) => {
  return axios.post(
    `${base}/api/EvaluationDimension/PostEvaluationItem`,
    params,
  );
};

// 编辑学生评价维度下的评价�?

export const editStudentEvaluationItem = (params) => {
  return axios.put(`${base}/api/EvaluationDimension/PutEvaluationItem`, params);
};

// 删除学生评价维度下的评价�?

export const deleteStudentEvaluationItem = (params) => {
  return axios.delete(`${base}/api/EvaluationDimension/DeleteEvaluationItem`, {
    params: params,
  });
};

// 导入值日检查类别及检查项

export const importDutyInspectItems = (params) => {
  return axios.post(
    `${base}/api/DutyInspectCategory/ImportDutyInspectItems`,
    params,
  );
};

// 导入学生评价维度及评价项

export const importEvaluationDimensions = (params) => {
  return axios.post(
    `${base}/api/EvaluationDimension/ImportEvaluationDimensions`,
    params,
  );
};

// 查询评价图标

export const getEvaluationIcons = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetEvaluationIcons`, {
    params: params,
  });
};

// 上传评价图标到本地静态目录，不经过 OSS
export const uploadEvaluationIcon = (formData) => {
  return axios.post(`${base}/api/EvaluationDimension/UploadEvaluationIcon`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteEvaluationIcon = (params) => {
  return axios.delete(`${base}/api/EvaluationDimension/DeleteEvaluationIcon`, {
    params,
  });
};

//查询推送日�?

export const getDeptInspectStats = (params) => {
  return axios.get(`${base}/api/DutyInspect/GetDeptInspectStats`, {
    params: params,
  });
};

// 获取班级德育统计详情网格（三级分类）

export const getDeptInspectDetailedStats = (params) => {
  return axios.get(`${base}/api/DutyInspect/GetDeptInspectDetailedStats`, {
    params: params,
  });
};

// 获取部门值日检查记录明�?

export const getRecordDetail = (params) => {
  return axios.get(`${base}/api/DutyInspect/GetRecordDetail`, {
    params: params,
  });
};

export const batchDeleteDutyRecord = (params) => {
  return axios.post(`${base}/api/DutyInspect/BatchDelete`, params).then(res => res.data);
};

// ════════════════════════════════════════════════════════════════
//  五星班级发布（FiveStarClassPublishAdminController，PC 后台）
// ════════════════════════════════════════════════════════════════

/** 当前发布列表（分页） */

export const getStudentScoreRecords = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetStudentScoreRecords`, {
    params: params,
  });
};

export const exportStudentScoreRecords = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/ExportStudentScoreRecords`, {
    params: params,
    responseType: "blob",
  });
};

/** 德育分红线报警记录分页 */
export const getEvaluationScoreAlertPage = (params) => {
  return axios.get(`${base}/api/EvaluationScoreAlert/GetPage`, { params });
};

/** 某条红线报警对应周期内的扣分明细 */
export const getEvaluationScoreAlertRecords = (params) => {
  return axios.get(`${base}/api/EvaluationScoreAlert/GetRecords`, { params });
};

/** 扣分汇总（按学生合计，口径同红线） */
export const getEvaluationDeductSummary = (params) => {
  return axios.get(`${base}/api/EvaluationScoreAlert/GetSummary`, { params });
};

/** 导出扣分汇总 */
export const exportEvaluationDeductSummary = (params) => {
  return axios.get(`${base}/api/EvaluationScoreAlert/ExportSummary`, { params, responseType: 'blob' });
};

/** 某学生在查询时间内的扣分明细 */
export const getEvaluationStudentDeductRecords = (params) => {
  return axios.get(`${base}/api/EvaluationScoreAlert/GetStudentRecords`, { params });
};

/** 学生评价报告导出记录分页（管理后台） */

export const getStudentScoreRanking = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/GetStudentScoreRanking`, {
    params: params,
  });
};

export const exportStudentScoreRanking = (params) => {
  return axios.get(`${base}/api/EvaluationDimension/ExportStudentScoreRanking`, {
    params: params,
    responseType: "blob",
  });
};

// 获取返校超时列表

export const moralOpsGetSchoolScope = (params) => {
  return axios.get(`${base}/api/MoralOpsMaintenance/GetSchoolScope`, { params });
};

export const moralOpsPreviewBackfillLedger = (data) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/PreviewBackfillLedger`, data);
};

export const moralOpsPreviewLedgerPipeline = (data) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/PreviewLedgerPipeline`, data);
};

export const moralOpsBackfillLedgerFromEvaluation = (data) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/BackfillLedgerFromEvaluation`, data);
};

export const moralOpsRunDailyRollup = (params) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/RunDailyRollup`, null, { params });
};

export const moralOpsRunConvertDailyToPoints = (params) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/RunConvertDailyToPoints`, null, { params });
};

export const moralOpsRunDailyPipelineRange = (data) => {
  return axios.post(`${base}/api/MoralOpsMaintenance/RunDailyPipelineRange`, data);
};

/** 运维台：反序卡号补扣款（ConsumerOpsMaintenanceController）。创建于 2026-05-30 */

export const getDutyInspectSmileSemesterRank = (params) => {
  return axios.get(`${base}/api/DutyInspect/GetDutyInspectSmileSemesterRank`, {
    params: params,
  });
};

// 导出学期值日笑脸评选排行

export const exportDutyInspectSmileSemesterRank = (params) => {
  return axios.get(`${base}/api/DutyInspect/ExportDutyInspectSmileSemesterRank`, {
    params: params,
    responseType: "blob",
  });
};

// 导出班级德育统计

export const exportDeptInspectStats = (params) => {
  return axios.get(`${base}/api/DutyInspect/ExportDeptInspectStats`, {
    params: params,
    responseType: "blob",
  });
};

// 导出学期每周班级总分汇总

export const exportDeptInspectSemesterWeeklySummary = (params) => {
  return axios.get(`${base}/api/DutyInspect/ExportDeptInspectSemesterWeeklySummary`, {
    params: params,
    responseType: "blob",
  });
};

// 导出检查记录明�?

export const exportRecordDetail = (params) => {
  return axios.get(`${base}/api/DutyInspect/ExportRecordDetail`, {
    params: params,
    responseType: "blob",
  });
};

// 魔点配置

export const zheshangGetClassAccounts = (params) =>
    axios.get(`${base}/api/MoralZheshangH5/GetClassAccounts`, { params });

/** 获取班级池流水（分页，可按班级筛选） */

export const zheshangGetClassLedger = (params) =>
    axios.get(`${base}/api/MoralZheshangH5/GetClassLedger`, { params });

/** 导出班级池全校流水（当前筛选条件，Excel） */

export const zheshangExportClassLedger = (params) =>
    axios.get(`${base}/api/MoralZheshangH5/ExportClassLedger`, {
        params,
        responseType: 'blob',
    });

/** 本班各任课教师额度一览（班主任工作台同源接口，德育员后台用于明细弹窗） */

export const zheshangGetClassTeacherQuotas = (params) =>
    axios.get(`${base}/api/MoralZheshangH5/GetClassTeacherQuotas`, { params });

/** 管理员批量向多班级发放德育分（每班同分值，支持跨年级多选） */

export const zheshangAdminBatchGrantClassPool = (data) =>
    axios.post(`${base}/api/MoralZheshangH5/AdminBatchGrantClassPool`, data);

/** 管理员撤回班级池发放 */

export const zheshangAdminRevokeGrant = (data) =>
    axios.post(`${base}/api/MoralZheshangH5/AdminRevokeGrant`, data);

/** 管理员核销德育实体币 */

export const zheshangWriteOffPhysicalCoin = (data) =>
    axios.post(`${base}/api/MoralZheshangH5/WriteOffPhysicalCoin`, data);

/** 撤回实体币核销 */

export const zheshangRevokeWriteOff = (data) =>
    axios.post(`${base}/api/MoralZheshangH5/RevokeWriteOff`, data);

/** 获取发分来源类型列表 */

export const zheshangGetGrantSourceTypes = (params) =>
    axios.get(`${base}/api/MoralZheshangH5/GetGrantSourceTypes`, { params });

/** 保存发分来源类型（新增/编辑/启用禁用） */

export const zheshangSaveGrantSourceType = (data) =>
    axios.post(`${base}/api/MoralZheshangH5/SaveGrantSourceType`, data);

// ════════════════════════════════════════════════════════════════
//  流动红旗后台管理员接口（FlowingRedFlagAdminController）
// ════════════════════════════════════════════════════════════════

/** 流动红旗排行。PC 已登录不传 dutyStaffTeacherId；手机/H5 须传。 */

export const lotteryAdminGetConfig = (params) =>
    axios.get(`${base}/api/ClassLotteryAdmin/GetConfig`, { params });

/** 场次列表（分页） */

export const lotteryAdminGetSessions = (params) =>
    axios.get(`${base}/api/ClassLotteryAdmin/GetSessions`, { params });

/** 场次流水明细（分页，含 IsGuaranteed） */

export const lotteryAdminGetSessionDraws = (params) =>
    axios.get(`${base}/api/ClassLotteryAdmin/GetSessionDraws`, { params });

/** 强制关闭场次 */

export const lotteryAdminCloseSession = (params) =>
    axios.put(`${base}/api/ClassLotteryAdmin/CloseSession`, null, { params });

/** 还原已结束场次（演示作废） */

export const lotteryAdminRevertSession = (params) =>
    axios.put(`${base}/api/ClassLotteryAdmin/RevertSession`, null, { params });

/** 班级奖品分页列表（params: classDepartmentId, page, pageSize, keyword?, prizeSource?, enabled?） */

export const lotteryAdminGetPrizes = (params) =>
    axios.get(`${base}/api/ClassLotteryAdmin/GetPrizes`, { params });

/** 新增班级奖品（管理端） */

export const lotteryAdminAddPrize = (data) =>
    axios.post(`${base}/api/ClassLotteryAdmin/AddPrize`, data);

/** 代维奖品 */

export const lotteryAdminUpdatePrize = (data) =>
    axios.put(`${base}/api/ClassLotteryAdmin/UpdatePrize`, data);

/** 软删班级奖品（params: classDepartmentId, prizeId） */

export const lotteryAdminDeletePrize = (params) =>
    axios.delete(`${base}/api/ClassLotteryAdmin/DeletePrize`, { params });

/** 班级汇总统计 */

export const lotteryAdminGetStats = (params) =>
    axios.get(`${base}/api/ClassLotteryAdmin/GetStats`, { params });

/** 后台代维班级抽奖配置 */

export const lotteryAdminSaveConfig = (data) =>
    axios.put(`${base}/api/ClassLotteryAdmin/SaveConfig`, data);

// ════════════════════════════════════════════════════════════════
//  校级积分抽奖管理（ClassLotterySchoolAdminController，德育处）
//  params/data 须含 schoolDepartmentId
// ════════════════════════════════════════════════════════════════

/** 获取校级抽奖配置（只读） */

export const lotterySchoolAdminGetConfig = (params) =>
    axios.get(`${base}/api/ClassLotterySchoolAdmin/GetConfig`, { params });

/** 保存校级抽奖配置 */

export const lotterySchoolAdminSaveConfig = (data) =>
    axios.put(`${base}/api/ClassLotterySchoolAdmin/SaveConfig`, data);

/** 校级奖品分页列表（params: schoolDepartmentId, page, pageSize, keyword?, enabled?） */

export const lotterySchoolAdminGetPrizes = (params) =>
    axios.get(`${base}/api/ClassLotterySchoolAdmin/GetPrizes`, { params });

/** 新增校级奖品（totalQuantity、maxWinsPerStudent 等） */

export const lotterySchoolAdminAddPrize = (data) =>
    axios.post(`${base}/api/ClassLotterySchoolAdmin/AddPrize`, data);

/** 更新校级奖品（含库存、权重、启用状态） */

export const lotterySchoolAdminUpdatePrize = (data) =>
    axios.put(`${base}/api/ClassLotterySchoolAdmin/UpdatePrize`, data);

/** 软删校级奖品（params: schoolDepartmentId, prizeId） */

export const lotterySchoolAdminDeletePrize = (params) =>
    axios.delete(`${base}/api/ClassLotterySchoolAdmin/DeletePrize`, { params });

/** 将校级奖 fork 为本班独立奖品（body 同 SaveClassLotteryPrizeRequest，必填 forkFromSchoolPrizeId、classDepartmentId） */

export const lotteryAdminForkSchoolPrize = (data) =>
    axios.post(`${base}/api/ClassLotteryAdmin/ForkSchoolPrize`, data);

// ════════════════════════════════════════════════════════════════
//  评价角色与维度权限（EvaluationRoleController）
// ════════════════════════════════════════════════════════════════

/** 获取学校评价角色列表（首次访问幂等创建预置角色） */
export const getEvaluationRoles = (params) => {
  return axios.get(`${base}/api/EvaluationRole/GetRoles`, { params });
};

/** 新增自定义评价角色 */
export const createEvaluationRole = (params) => {
  return axios.post(`${base}/api/EvaluationRole/CreateRole`, params);
};

/** 更新评价角色名称与排序 */
export const updateEvaluationRole = (params) => {
  return axios.put(`${base}/api/EvaluationRole/UpdateRole`, params);
};

/** 启用/停用评价角色 */
export const setEvaluationRoleEnabled = (params) => {
  return axios.post(`${base}/api/EvaluationRole/SetRoleEnabled`, params);
};

/** 删除自定义评价角色 */
export const deleteEvaluationRole = (params) => {
  return axios.delete(`${base}/api/EvaluationRole/DeleteRole`, { params });
};

/** 分页查询角色成员 */
export const getEvaluationRoleMembers = (params) => {
  return axios.get(`${base}/api/EvaluationRole/GetMembers`, { params });
};

/** 批量保存角色成员（TeacherMaster.Id） */
export const saveEvaluationRoleMembers = (params) => {
  return axios.post(`${base}/api/EvaluationRole/SaveMembers`, params);
};

/** 批量移除角色成员 */
export const removeEvaluationRoleMembers = (params) => {
  return axios.post(`${base}/api/EvaluationRole/RemoveMembers`, params);
};

/** 设置角色成员启用状态（全体教职工：false=排除） */
export const setEvaluationRoleMemberEnabled = (params) => {
  return axios.post(`${base}/api/EvaluationRole/SetMemberEnabled`, params);
};

/** 快捷导入角色成员：ClassTeacher | HostelAdmin | DutyLeader */
export const quickImportEvaluationRoleMembers = (params) => {
  return axios.post(`${base}/api/EvaluationRole/QuickImportMembers`, params);
};

/** 预览快捷导入候选人员（浏览后可剔除再保存） */
export const previewQuickImportEvaluationRoleMembers = (params) => {
  return axios.post(`${base}/api/EvaluationRole/PreviewQuickImportMembers`, params);
};

/** 查询维度可见角色配置 */
export const getEvaluationDimensionPermissions = (params) => {
  return axios.get(`${base}/api/EvaluationRole/GetDimensionPermissions`, { params });
};

/** 批量查询维度可见角色配置，供维度列表一次性加载 */
export const getEvaluationDimensionPermissionsBatch = (params) => {
  return axios.post(`${base}/api/EvaluationRole/GetDimensionPermissionsBatch`, params);
};

/** 保存维度可见角色（按学校、维度整体替换） */
export const saveEvaluationDimensionPermissions = (params) => {
  return axios.post(`${base}/api/EvaluationRole/SaveDimensionPermissions`, params);
};

// ════════════════════════════════════════════════════════════════
//  学生专项加分导入（StudentEvaluationSpecialImportController）
// ════════════════════════════════════════════════════════════════

/** 导出多班级专项加分 Excel 模板 */
export const exportStudentEvaluationSpecialImportTemplate = (data) => {
  return axios.post(`${base}/api/StudentEvaluationSpecialImport/ExportTemplate`, data, {
    responseType: 'blob',
    skipGlobalHttpErrorToast: true,
  });
};

/** 上传 Excel 预览校验（不落库） */
export const previewStudentEvaluationSpecialImport = (formData) => {
  return axios.post(`${base}/api/StudentEvaluationSpecialImport/Preview`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** 确认导入（全有或全无事务） */
export const confirmStudentEvaluationSpecialImport = (formData) => {
  return axios.post(`${base}/api/StudentEvaluationSpecialImport/Confirm`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** 导入批次历史分页 */
export const getStudentEvaluationSpecialImportBatches = (params) => {
  return axios.get(`${base}/api/StudentEvaluationSpecialImport/GetBatches`, { params });
};

/** 导入批次明细 */
export const getStudentEvaluationSpecialImportBatchDetails = (params) => {
  return axios.get(`${base}/api/StudentEvaluationSpecialImport/GetBatchDetails`, { params });
};

// 班级小组竞赛
export const getClassGroupCompetitionConfig = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/GetConfig`, { params });
};

export const saveClassGroupCompetitionConfig = (data) => {
  return axios.post(`${base}/api/ClassGroupCompetition/SaveConfig`, data);
};

export const getClassGroupCompetitions = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/ListCompetitions`, { params });
};

export const getClassGroupCompetitionSummary = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/GetSummary`, { params });
};

export const getClassGroupCompetitionClassStudents = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/GetClassStudents`, { params });
};

export const saveClassGroupCompetition = (data) => {
  return axios.post(`${base}/api/ClassGroupCompetition/SaveCompetition`, data);
};

export const deleteClassGroupCompetition = (params) => {
  return axios.post(`${base}/api/ClassGroupCompetition/DeleteCompetition`, null, { params });
};

export const getClassGroupCompetitionTeams = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/ListTeams`, { params });
};

export const saveClassGroupCompetitionTeam = (data) => {
  return axios.post(`${base}/api/ClassGroupCompetition/SaveTeam`, data);
};

export const deleteClassGroupCompetitionTeam = (params) => {
  return axios.post(`${base}/api/ClassGroupCompetition/DeleteTeam`, null, { params });
};

export const addClassGroupCompetitionMembers = (data) => {
  return axios.post(`${base}/api/ClassGroupCompetition/AddTeamMembers`, data);
};

export const removeClassGroupCompetitionMember = (data) => {
  return axios.post(`${base}/api/ClassGroupCompetition/RemoveTeamMember`, data);
};

export const getClassGroupCompetitionRanking = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/GetGroupRanking`, { params });
};

export const getClassGroupCompetitionStudentRanking = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/GetTeamStudentRanking`, { params });
};

export const exportClassGroupCompetitions = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/ExportCompetitions`, {
    params,
    responseType: 'blob',
  });
};

export const exportClassGroupCompetitionStudentRanking = (params) => {
  return axios.get(`${base}/api/ClassGroupCompetition/ExportStudentRanking`, {
    params,
    responseType: 'blob',
  });
};

// ---------- 校徽订购管理（BadgeOrderAdminController）----------

/** 获取全局配置（开关、办理方式、支付宝、产品详情等） */
